import { useEffect } from 'react';
import urlTemplate from 'url-template';
import type { JobRunDetail } from 'src/apis/transparency-reporting/types';
import { useAxios } from 'src/hooks/use-axios';

export const JOB_RUN_DETAIL_URL = `${PRISMA_CONFIG.transparencyReporting}/job-runs/{id}`;

type HookConfig = {
  jobRunDetailUrl: string;
  id: number;
};

type ExecuteProps = {
  url: string;
};

export function useJobRunDetail({ jobRunDetailUrl, id }: HookConfig) {
  const request = useAxios(
    (axios, baseConfig, { url }: ExecuteProps) =>
      axios.request<JobRunDetail>({
        ...baseConfig,
        url,
      }),
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    const url = urlTemplate.parse(jobRunDetailUrl).expand({ id });

    request.execute({ url });
    // oxlint-disable-next-line exhaustive-deps
  }, [id]);

  return request;
}

export type JobRunDetailRequest = ReturnType<typeof useJobRunDetail>;
